import HttpRouter from "../services/HttpRouter";

export default {
    getTeachers ({schoolId}, successCallback) {
        HttpRouter.get(null, 'school/' + schoolId + '/teachers').then(
            function (response) {
                var teachers = response.data.data;
                successCallback(teachers);
            },
            function (response) {
                console.error('Problem loading teachers', response);
            }
        );
    },


}